import {StateProvider} from "@uirouter/angularjs";
import {FeatureNames, UserConfigProvider} from "../../types/UserConfig";
import {ClientDashboardService} from "../client/service/ClientDashboardService";
import {ClientDashboardModel} from "../client/models/ClientDashboardModel";
import {DashboardView} from "../oms/view/DashboardViewComponent";

export function routerConfig($stateProvider: StateProvider, userConfigProvider: UserConfigProvider) {

    const pageTitle = "iInvest Options Calculator";
    const hasAdviserDashboard = userConfigProvider.config.features[FeatureNames.SCREEN_ADVISER_DASHBOARD];

    if (hasAdviserDashboard) {
        $stateProvider.state("home", {
            url: "/?view",
            component: DashboardView,
            data: {
                pageTitle
            },
            params: {
                view: {
                    dynamic: true,
                    type: "int"
                }
            }
        });
    } else if (userConfigProvider.config.client != null) {
        $stateProvider.state("home", {
            url: "/?view",
            component: "tfClientDashboardView",
            data: {
                pageTitle
            },
            resolve: {
                model: clientModelResolver
            },
            params: {
                view: null
            }
        });
    } else {
        $stateProvider.state("home", {
            url: "/",
            templateUrl: "app/home/home.tpl.html",
            controller: "homeCtrl as home",
            data: {
                pageTitle
            }
        });
    }
}

/** @ngInject */
export const clientModelResolver = (clientDashboardService: ClientDashboardService): Promise<ClientDashboardModel> => {
    return clientDashboardService.model();
};
